import React, { useMemo } from 'react';
import { KEYBOARD_KEYS } from '@keen.io/ui-core';
import { Container, IntervalButton } from './SupportedInterval.styles';
import { INTERVALS } from './constants';

var SupportedInterval = function SupportedInterval(_ref) {
  var interval = _ref.interval,
      onChange = _ref.onChange;
  var options = useMemo(function () {
    return INTERVALS.map(function (name) {
      return {
        label: name,
        value: name
      };
    });
  }, []);
  return React.createElement(Container, {
    "data-testid": "supported-interval"
  }, options.map(function (option) {
    return React.createElement(IntervalButton, {
      key: option.value,
      isActive: interval === option.value,
      onClick: function onClick() {
        return onChange(option.value);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KEYBOARD_KEYS.ENTER) {
          onChange(option.value);
        }
      },
      role: "button",
      tabIndex: 0
    }, option.label);
  }));
};

export default SupportedInterval;